import React from 'react';
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import { colors } from '../../brand-colors';

/**
 * Current Month Chart - Donut showing Core Product, Tripwire, Leads breakdown
 */
function CurrentMonthChart({ data }) {
  if (!data || (data.core_product === 0 && data.tripwire === 0 && data.leads === 0)) {
    return (
      <div style={styles.placeholder}>
        <p>No data for current month</p>
        <small>Data syncs daily from GHL</small>
      </div>
    );
  }

  const chartData = [
    { name: 'Core Product', value: data.core_product || 0, color: colors.tealDark },
    { name: 'Tripwire', value: data.tripwire || 0, color: colors.teal },
    { name: 'Leads', value: data.leads || 0, color: colors.tealMid }
  ].filter(item => item.value > 0);

  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={2}
          dataKey="value"
          label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
          labelLine={false}
        >
          {chartData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            color: colors.greyDarkest
          }}
          formatter={(value) => [
            typeof value === 'number' && value < 100
              ? value.toLocaleString()
              : `$${value.toLocaleString()}`,
            ''
          ]}
        />
        <Legend
          wrapperStyle={{ color: colors.grey }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}

const styles = {
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center'
  }
};

export default CurrentMonthChart;
